import businessEntityTypes from '../../constants/businessEntityTypes';

export const AdditionalUnderReviewDetailsEntities = [
  businessEntityTypes.limitedLiabilityCompany,
  businessEntityTypes.soleProprietorship,
  businessEntityTypes.independentContractor,
  businessEntityTypes.eligibleSelfEmployedIndividual,
];
